module.exports = __webpack_public_path__ + "img/market-research.b070ef08.svg";